import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerRoutingModule } from './customer-routing.module';
import { NewCustomerComponent } from './new-customer/new-customer.component';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../app-material/app-material.module';
import { ListCustomerComponent } from './list-customer/list-customer.component';

@NgModule({
  imports: [
    CommonModule,
    CustomerRoutingModule,
    AppMaterialModule,
    FormsModule
  ],
  declarations: [NewCustomerComponent, ListCustomerComponent]
})
export class CustomerModule { }
